import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "m--dialog" }

import Mbutton from '../MButton/index.vue'
import { debounce } from '@/utils/tools';
import { reactive, ref, useAttrs, PropType, computed } from 'vue';

const __default__ = {
  name: "MDialog",
  inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  dialogConfig: {
    type: Object as PropType<DialogConfigType>,
    default: () => ({}),
  },
  nativeConfig: {
    type: Object,
    default: {}
  },
  specialClass: {
    type: String,
    default: ''
  },
  autoLoading: {
    type: Boolean,
    default: false
  },
  // 是否禁用确认按钮
  isConFirmDisabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'onConfirm', 'onClose'],
  setup(__props, { emit }) {

const props = __props;



const dialogRef = ref(null)

const dialogVisible = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})

// const confirm = () => {
//   emit('onConfirm')
// }

const confirm = debounce((done) => {
  emit('onConfirm', done)
}, 500)


const close = () => {
  if (props.modelValue) {
    emit('update:modelValue', false)
    emit('onClose')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, _mergeProps({
      ref_key: "dialogRef",
      ref: dialogRef,
      onClose: close,
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event))
    }, __props.nativeConfig, {
      title: _ctx.$t(__props.dialogConfig.title || ''),
      "destroy-on-close": __props.dialogConfig.destroyOnClose || false
    }), {
      footer: _withCtx(() => [
        (__props.dialogConfig.isShowFooter ?? true)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_button, {
                class: "mk-op-btn mk-op-btn-non-focus",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('关闭')), 1)
                ]),
                _: 1
              }),
              (__props.dialogConfig.isShowConfirm ?? true)
                ? (_openBlock(), _createBlock(Mbutton, {
                    key: 0,
                    disabled: __props.isConFirmDisabled,
                    class: "mk-op-btn mk-op-btn-main",
                    onHandleClick: _unref(confirm),
                    "auto-loading": __props.autoLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onHandleClick", "auto-loading"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "footer")
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "title", "destroy-on-close"])
  ]))
}
}

})